import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useLocation, useHistory, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import MyStorage from './util/storage'
import { Oval as Loader } from 'react-loader-spinner'
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast'
import { db1, storage1, auth1 } from '../../firebase/firebase1'
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import add from '../assets/add.png';
import cross from '../assets/delete.png';
import Resizer from "react-image-file-resizer";

import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { MenuProps, useStyles } from './util/picker';
import firebase from "firebase/compat/app";
import Api from './api/api';

let i = 1
let imageUrls = []

const AddRecipe = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const model = location.state.model
    const type = location.state.type
    const editMode = model != null

    const classes = useStyles()

    const recType = ['Vegetarian', 'Vegan', 'Keto', 'Caribbean', 'Creole', 'Low Carb', 'High protein', 'Pescatarian', 'Other']
    const [selectedRecType, setSelectedRecType] = React.useState([])
    const isAllRecipeTypeSelected = recType.length > 0 && selectedRecType.length === recType.length

    const mealType = ['Breakfast', 'Lunch', 'Dinner']
    const [selectedMealType, setSelectedMealType] = React.useState([]);
    const isAllMealTypeSelected = mealType.length > 0 && selectedMealType.length === mealType.length;

    const [title, setTitle] = useState('');
    const [calorie, setCalorie] = useState('0');
    const [cookingTime, setCookingTime] = useState('');
    const [loader, setLoader] = useState(false);
    const addScreenshot = useRef(null);
    const [images, setImages] = useState([{}]);
    const [recOfWeek, setRecOfWeek] = useState(false);
    const [recOfWeekId, setRecOfWeekId] = useState('');
    const [hide, setHide] = useState(false);

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (editorState) => {
        console.log(JSON.stringify(editorState));
        setEditorState(editorState)
    };

    const onChangeMealType = (event) => {
        const value = event.target.value;
        console.log('value: ' + value);
        if (value[value.length - 1] === "all") {
            console.log('all');
            let temp = selectedMealType.length === mealType.length ? [] : mealType
            setSelectedMealType(temp);
            return;
        }
        setSelectedMealType(value)
    }

    const onChangeRecType = (event) => {
        const value = event.target.value;
        console.log('value: ' + value);
        if (value[value.length - 1] === "all") {
            console.log('all');
            let temp = selectedRecType.length === recType.length ? [] : recType
            setSelectedRecType(temp);
            return;
        }
        setSelectedRecType(value);
    };

    const checkValid = (key) => {
        return model[key] !== undefined && model[key] != null && model[key] !== '' && model[key] !== 'null'
    };

    useEffect(() => {

        if (editMode) {
            setTitle(model.title)
            setCalorie(model.calorie ? model.calorie : '')
            setCookingTime(model.cookingTime ? model.cookingTime : '')
            setHide(model.hide === undefined ? false : model.hide)
            // check recipe of week
            Api.getRecipeOfWeek((recId) => {
                let recOfWeek = recId === model.id
                let recOfWeekId = recId
                console.log('recOfWeek: ' + recOfWeek);
                console.log('recOfWeekId: ' + recOfWeekId);
                setRecOfWeek(recOfWeek)
                setRecOfWeekId(recOfWeekId)
            }, (error) => {
                //
            })

            if (checkValid('recipe_type'))
                setSelectedRecType(
                    // On autofill we get a stringified value.
                    typeof model.recipe_type === 'string' ? model.recipe_type.split(',') : model.recipe_type,
                );

            if (checkValid('meal_type'))
                setSelectedMealType(
                    // On autofill we get a stringified value.
                    typeof model.meal_type === 'string' ? model.meal_type.split(',') : model.meal_type,
                );

            const contentBlock = htmlToDraft(model.body);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            setEditorState(EditorState.createWithContent(contentState))

            const blocksFromHTML = convertFromHTML(model.body);
            const state = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap,
            );
            setEditorState(EditorState.createWithContent(state))

            let images = [{}];
            for (let i = 0; i < model.images.length; i++) {
                images = images.concat({
                    file: null,
                    url: model.images[i],
                    name: '',
                })
                if (i === model.images.length - 1)
                    setImages(images);
            }
        }
    }, [])

    if (!MyStorage.isLogin()) {
        console.log('not logged in');
        navigate('/login')
        return null
    }

    const addNewRecipe = () => {
        if (title === '' || selectedRecType.length == 0 || selectedMealType.length == 0) {
            showToast('error', 'Fill complete form!')
            return
        }

        let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        console.log('body: ' + body);
        if (body.length < 10) {
            showToast('error', 'Please enter body!')
            return
        }

        setLoader(true);
        uploader(title, body)
    };

    const editNewModel = () => {
        if (title == '' || selectedRecType.length == 0 || selectedMealType.length == 0) {
            showToast('error', 'Fill complete form!')
            return
        }

        let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        console.log('body: ' + body);
        if (body.length < 10) {
            showToast('error', 'Please enter body!')
            return
        }

        setLoader(true);
        // update images
        i = 1
        imageUrls = []
        updater()

        // update info
        db1.collection('recipes')
            .doc(model.id)
            .set({
                title: title,
                cookingTime: cookingTime,
                calorie: calorie,
                body: body,
                recipe_type: selectedRecType,
                meal_type: selectedMealType,
                hide: hide,
            }, { merge: true })
            .then(() => {
                setLoader(false);
                showToast('success', 'Recipe Saved!')
                navigate(-1)
            })
            .catch(error => {
                showToast('error', 'Save Failed!');
            });

        if (recOfWeek) {
            if (recOfWeekId === model.id) {
                // already added
                return
            }
            db1.collection('recipeOfWeek')
                .doc('recipeOfWeek')
                .set({
                    recId: model.id,
                }, { merge: true })
            sendRecOfWeekNotification(model.id)
        }
    };

    const uploader = (title_, body_) => {
        if (images.length == 1) {
            addRecipeToFirebase(title_, body_, [])
            return
        }
        const image = images[i];
        uploadPhoto(
            'recipes/' + image.file.name,
            image.file,
            (imageUrl) => {
                console.log('imageUrl: ' + imageUrl);
                imageUrls.push(imageUrl)
                console.log('image added');
                if (i === images.length - 1) {
                    addRecipeToFirebase(title_, body_, imageUrls)
                }
                else {
                    console.log('next upload');
                    i++
                    uploader(title_, body_)
                }
            }
        );
    };

    const addRecipeToFirebase = (title, body, urls) => {
        console.log('add recipe');
        let recipe = {
            title: title,
            cookingTime: cookingTime,
            calorie: calorie,
            body: body,
            images: urls,
            liked: 0,
            recipe_type: selectedRecType,
            meal_type: selectedMealType,
            added_date: parseInt(moment() + ''),
            hide: hide,
        };
        console.log(JSON.stringify(recipe));
        db1.collection('recipes')
            .add(recipe)
            .then((doc) => {
                setLoader(false);
                showToast('success', 'Recipe Saved!')
                if (recOfWeek) {
                    // send recipe of week push
                    db1.collection('recipeOfWeek')
                        .doc('recipeOfWeek')
                        .set({
                            recId: doc.id,
                        }, { merge: true })
                    sendRecOfWeekNotification(doc.id)
                }
                else {
                    // send push
                    sendNewRecipeNotification(doc.id)
                }
                navigate(-1)
            })
            .catch(error => {
                showToast('error', 'Save Failed!');
            });
    };

    const sendRecOfWeekNotification = (docId) => {
        let title = 'Recipe of the Week by Liviq'
        let body = 'Check out Recipe of the Week by Liviq!'

        // add to database
        let obj = {
            title: title,
            body: body,
            type: 'recipe',
            docId: docId, // recipe, video, exercise, mind
            added_date: firebase.firestore.FieldValue.serverTimestamp()
        }
        db1.collection('notifications').add(obj)

        Api.sendPushToAll(title, body,
            () => {
                //
            },
            () => {
                //
            })
    };


    const sendNewRecipeNotification = (docId) => {
        let title = 'New Recipe by Liviq'
        let body = 'Check out the new recipe by Liviq!'

        // add to database
        let obj = {
            title: title,
            body: body,
            type: 'recipe',
            docId: docId, // recipe, video, exercise, mind
            added_date: firebase.firestore.FieldValue.serverTimestamp()
        }
        db1.collection('notifications').add(obj)

        Api.sendPushToAll(title, body,
            () => {
                //
            },
            () => {
                //
            })
    };

    const updater = () => {
        if (images.length == 1) {
            return
        }
        const image = images[i];
        if (image.file == null) {
            console.log('already uploaded');
            imageUrls.push(image.url)
            if (i === images.length - 1) {
                updateRecipeImageUrls()
            }
            else {
                console.log('next upload');
                i++
                updater()
            }
            return
        }
        uploadPhoto(
            'recipes/' + image.file.name,
            image.file,
            (imageUrl) => {
                console.log('imageUrl: ' + imageUrl);
                imageUrls.push(imageUrl)
                console.log('image added');
                if (i === images.length - 1) {
                    console.log('update recipe');
                    updateRecipeImageUrls()
                }
                else {
                    console.log('next upload');
                    i++
                    updater()
                }
            }
        );
    };

    const updateRecipeImageUrls = () => {
        console.log('imageUrls: ' + imageUrls.length);
        db1.collection('recipes')
            .doc(model.id)
            .set({
                images: imageUrls
            }, { merge: true })
    };

    const uploadPhoto = (path, photo, onSuccess) => {
        const uploadTask = storage1.ref(path).put(photo);
        uploadTask.on('state_changed',
            (snapshot) => {
                // const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            },
            (error) => {
                console.log(error);
            },
            () => {
                storage1.ref(path).getDownloadURL().then((url) => {
                    onSuccess(url);
                })
            });
    };

    const resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, 1024, 1024, 'JPEG', 90, 0,
            uri => {
                resolve(uri);
            }, 'file');
    });

    const handleAddImage = async (event) => {
        let temp = [...images];
        for (let i = 0; i < event.target.files.length; i++) {
            const file = event.target.files[i];

            console.log('size1: ' + file.size);
            const resizedImage = await resizeFile(file)
            // const img = resizedImage;
            // const base64str = img.data
            // const imgExt = img.ext
            // const resizedFile = Compress.convertBase64ToFile(base64str, imgExt)
            console.log('size2: ' + resizedImage.size);

            let url = URL.createObjectURL(resizedImage);
            temp = temp.concat({ file: resizedImage, url: url, name: resizedImage.name });
        }
        setImages(temp);
    };

    const showProductImages = () => {
        return images.map((item, index) => {
            if (index == 0) {
                return (
                    <div style={{ marginRight: 10, marginBottom: 10 }}>
                        <div onClick={() => {
                            // browse screenshot
                            addScreenshot.current.click();
                        }} style={{ width: 100, height: 100, backgroundColor: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src={add} style={{ width: 30, height: 30 }} />
                            <input
                                multiple
                                type='file'
                                style={{ display: 'none' }}
                                ref={addScreenshot}
                                onChange={handleAddImage}
                            />
                        </div>
                    </div>
                );
            }
            return (
                <div style={{ display: 'inline-flex', width: 100, height: 100, marginRight: 10, marginBottom: 10 }}>
                    <img src={item.url} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    <div onClick={() => {
                        // delete screenshot
                        const temp = images.filter((item, j) => {
                            return index !== j; //false will delete
                        });
                        setImages(temp);
                    }} style={{ width: 25, height: 25, marginLeft: -25, marginTop: 0, backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={cross} style={{ width: 20, height: 20 }} />
                    </div>
                </div>
            );
        });
    }

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Add Recipe
                </div>
            </div>

            <div
                style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                <div style={{ paddingTop: 30, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflow: 'scroll' }}>
                    <Form className='form' style={{ padding: 20, backgroundColor: 'white', borderRadius: 10, minWidth: 600 }}>

                        <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <Input
                                    style={{ fontSize: 16 }}
                                    type='text'
                                    placeholder='Recipe Title'
                                    value={title}
                                    onChange={(event) => {
                                        console.log('change: ' + event.target.value);
                                        setTitle(event.target.value)
                                    }} />
                            </FormGroup>
                            <FormGroup style={{ marginTop: 10, width: '100%' }}>
                                <div>Description</div>
                                <Editor
                                    editorStyle={{ backgroundColor: '#fafafa', paddingLeft: 10, paddingRight: 10, height: 250 }}
                                    editorState={editorState}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    onEditorStateChange={onEditorStateChange}
                                />
                            </FormGroup>

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, alignSelf: 'flex-start' }}>
                                <div>
                                    Recipe Type
                                </div>
                                <FormControl sx={{ m: 0, minWidth: 320 }} size="small">
                                    {/* <InputLabel id="mutiple-select-label">Areas</InputLabel> */}
                                    <Select
                                        labelId="mutiple-select-label"
                                        multiple
                                        value={selectedRecType}
                                        onChange={onChangeRecType}
                                        renderValue={(selectedRecType) => selectedRecType.join(", ")}
                                        MenuProps={MenuProps}>
                                        <MenuItem
                                            value="all"
                                            classes={{
                                                root: isAllRecipeTypeSelected ? classes.selectedAll : ""
                                            }}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    classes={{ indeterminate: classes.indeterminateColor }}
                                                    checked={isAllRecipeTypeSelected}
                                                    indeterminate={
                                                        selectedRecType.length > 0 && selectedRecType.length < recType.length
                                                    }
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.selectAllText }}
                                                primary="Select All"
                                            />
                                        </MenuItem>
                                        {recType.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                <ListItemIcon>
                                                    <Checkbox checked={selectedRecType.indexOf(option) > -1} />
                                                </ListItemIcon>
                                                <ListItemText primary={option} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, alignSelf: 'flex-start' }}>
                                <div>
                                    Meal Type
                                </div>
                                <FormControl sx={{ m: 0, minWidth: 320 }} size="small">
                                    {/* <InputLabel id="mutiple-select-label">Areas</InputLabel> */}
                                    <Select
                                        labelId="mutiple-select-label"
                                        multiple
                                        value={selectedMealType}
                                        onChange={onChangeMealType}
                                        renderValue={(selectedMealType) => selectedMealType.join(", ")}
                                        MenuProps={MenuProps}>
                                        <MenuItem
                                            value="all"
                                            classes={{
                                                root: isAllMealTypeSelected ? classes.selectedAll : ""
                                            }}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    classes={{ indeterminate: classes.indeterminateColor }}
                                                    checked={isAllMealTypeSelected}
                                                    indeterminate={
                                                        selectedMealType.length > 0 && selectedMealType.length < mealType.length
                                                    }
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.selectAllText }}
                                                primary="Select All"
                                            />
                                        </MenuItem>
                                        {mealType.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                <ListItemIcon>
                                                    <Checkbox checked={selectedMealType.indexOf(option) > -1} />
                                                </ListItemIcon>
                                                <ListItemText primary={option} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div style={{ marginTop: 12, alignSelf: 'flex-start' }}>
                                Est. Calorie Count
                            </div>
                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <Input
                                    style={{ fontSize: 16 }}
                                    type='text'
                                    placeholder=''
                                    value={calorie}
                                    onChange={(event) => {
                                        console.log('change: ' + event.target.value);
                                        setCalorie(event.target.value)
                                    }} />
                            </FormGroup>

                            <div style={{ marginTop: 12, alignSelf: 'flex-start' }}>
                                Est. Cooking Time
                            </div>
                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <Input
                                    style={{ fontSize: 16 }}
                                    type='text'
                                    placeholder=''
                                    value={cookingTime}
                                    onChange={(event) => {
                                        console.log('change: ' + event.target.value);
                                        setCookingTime(event.target.value)
                                    }} />
                            </FormGroup>

                            <FormGroup style={{ display: 'flex', flexDirection: 'column', marginTop: 10, alignSelf: 'flex-start' }}>
                                <div>Image:</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 5 }}>
                                    {showProductImages()}
                                </div>
                            </FormGroup>

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, alignSelf: 'flex-start' }}>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        classes={{ indeterminate: classes.indeterminateColor }}
                                        checked={recOfWeek}
                                        onChange={(event) => {
                                            console.log('val: ' + event.target.checked);
                                            setRecOfWeek(event.target.checked)
                                        }}
                                    />
                                    <div style={{ marginTop: 12 }}>Recipe of the Week?</div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, alignSelf: 'flex-start' }}>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        classes={{ indeterminate: classes.indeterminateColor }}
                                        checked={hide}
                                        onChange={(event) => {
                                            setHide(event.target.checked)
                                        }}
                                    />
                                    <div style={{ marginTop: 12 }}>Hide Recipe?</div>
                                </div>
                            </div>

                        </div>

                        <Button
                            className='btn-block btn-dark'
                            style={{ marginTop: 15, fontSize: 16, width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 50 }}
                            onClick={() => {
                                if (!editMode)
                                    addNewRecipe()
                                else
                                    editNewModel()
                            }}>
                            Save Recipe
                        </Button>

                    </Form>
                </div>
            </div>

            {loader ?
                <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
                    <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
                        <Loader
                            type="ThreeDots"
                            color="white"
                            height={70}
                            width={70}
                            visible={true} />
                    </div>
                </div>
                :
                null
            }

            <div>
                <ToastContainer />
            </div>

        </div>
    );
}

export default AddRecipe;